export enum FiniteStateMachineSortBy {
  None = 0,
  NameAsc = 1,
  NameDesc = 2,
  IntervalAsc = 3,
  IntervalDesc = 4,
  CreatedDateAsc = 5,
  CreatedDateDesc = 6,
  ModifiedDateAsc = 7,
  ModifiedDateDesc = 8
}